const getOrgLogo = () => {
  try {
    const agencyData = localStorage.getItem('agency');
    if (agencyData && agencyData !== 'null') {
      const profile = JSON.parse(agencyData);
      if (profile?.organizationEntity?.logo) {
        return `data:image/png;base64,${profile.organizationEntity.logo}`;
      }
    }
  } catch {
    return null;
  }
  return null;
};

export default getOrgLogo;
